import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackDealSaleBannerClick, trackDealSaleBannerShow } from './tracking';
import { configSelector } from '../../../selectors/configSelector';
import { DealSaleBanner } from '../../components/DealSaleBanner';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

/**
 * Контейнер баннера "Циан.Сделка" для смешанной выдачи.
 */
export const DealSaleBannerContainer = () => {
  const config = useSelector(configSelector);
  const url = config.get<string>('deal-sale-promo-frontend.baseUrl') || '';
  const isMobile = useDeviceType() === 'phone';

  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(() => {
    trackDealSaleBannerClick(jsonQuery, source);
  }, [jsonQuery, source]);

  const handleShow = React.useCallback(() => {
    trackDealSaleBannerShow(jsonQuery, source);
  }, [jsonQuery, source]);

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <DealSaleBanner isMobile={isMobile} url={url} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};

DealSaleBannerContainer.displayName = 'DealSaleBannerContainer';
